/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Domain_Search_Modal_Name_SuggestionsInputs */

const en_domain_search_modal_name_suggestions = /** @type {(inputs: Domain_Search_Modal_Name_SuggestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name suggestions`)
};

const es_domain_search_modal_name_suggestions = /** @type {(inputs: Domain_Search_Modal_Name_SuggestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugerencias de nombres`)
};

const fr_domain_search_modal_name_suggestions = /** @type {(inputs: Domain_Search_Modal_Name_SuggestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggestions de noms`)
};

const de_domain_search_modal_name_suggestions = /** @type {(inputs: Domain_Search_Modal_Name_SuggestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namensvorschläge`)
};

/** @type {(inputs: Domain_Search_Modal_Name_SuggestionsInputs) => LocalizedString} */
const ja_domain_search_modal_name_suggestions = en_domain_search_modal_name_suggestions;

/** @type {(inputs: Domain_Search_Modal_Name_SuggestionsInputs) => LocalizedString} */
const zh_domain_search_modal_name_suggestions = en_domain_search_modal_name_suggestions;

/** @type {(inputs: Domain_Search_Modal_Name_SuggestionsInputs) => LocalizedString} */
const ar_domain_search_modal_name_suggestions = en_domain_search_modal_name_suggestions;

/** @type {(inputs: Domain_Search_Modal_Name_SuggestionsInputs) => LocalizedString} */
const id_domain_search_modal_name_suggestions = en_domain_search_modal_name_suggestions;

/** @type {(inputs: Domain_Search_Modal_Name_SuggestionsInputs) => LocalizedString} */
const it_domain_search_modal_name_suggestions = en_domain_search_modal_name_suggestions;

/** @type {(inputs: Domain_Search_Modal_Name_SuggestionsInputs) => LocalizedString} */
const ru_domain_search_modal_name_suggestions = en_domain_search_modal_name_suggestions;

/** @type {(inputs: Domain_Search_Modal_Name_SuggestionsInputs) => LocalizedString} */
const pt_domain_search_modal_name_suggestions = en_domain_search_modal_name_suggestions;

/** @type {(inputs: Domain_Search_Modal_Name_SuggestionsInputs) => LocalizedString} */
const ko_domain_search_modal_name_suggestions = en_domain_search_modal_name_suggestions;

/**
* | output |
* | --- |
* | "Name suggestions" |
*
* @param {Domain_Search_Modal_Name_SuggestionsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_search_modal_name_suggestions = /** @type {((inputs?: Domain_Search_Modal_Name_SuggestionsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Search_Modal_Name_SuggestionsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_search_modal_name_suggestions(inputs)
	if (locale === "es") return es_domain_search_modal_name_suggestions(inputs)
	if (locale === "fr") return fr_domain_search_modal_name_suggestions(inputs)
	if (locale === "de") return de_domain_search_modal_name_suggestions(inputs)
	if (locale === "ja") return ja_domain_search_modal_name_suggestions(inputs)
	if (locale === "zh") return zh_domain_search_modal_name_suggestions(inputs)
	if (locale === "ar") return ar_domain_search_modal_name_suggestions(inputs)
	if (locale === "id") return id_domain_search_modal_name_suggestions(inputs)
	if (locale === "it") return it_domain_search_modal_name_suggestions(inputs)
	if (locale === "ru") return ru_domain_search_modal_name_suggestions(inputs)
	if (locale === "pt") return pt_domain_search_modal_name_suggestions(inputs)
	return ko_domain_search_modal_name_suggestions(inputs)
});